/**
 * Route for `carrier-isp-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CarrierIspTargetingPage } from "../features/carrier-isp-targeting/CarrierIspTargetingPage";

export const carrierIspTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/carrier-isp-targeting",
	component: CarrierIspTargetingPage,
});

export default carrierIspTargetingRoute;
